import React from 'react';
import './Footer.css';
import { Facebook, Instagram, LocationOn, Phone, Email } from '@mui/icons-material';
import { useTheme } from '@mui/material';
import { getContactMethods, officeHours } from '../config/contactConfig';

const Footer = () => {
  const theme = useTheme();
  const contactMethods = getContactMethods(theme);

  // Find specific contact methods
  const phoneMethod = contactMethods.find(method => method.title === 'Call Us');
  const emailMethod = contactMethods.find(method => method.title === 'Email Us');
  const locationMethod = contactMethods.find(method => method.title === 'Visit Us');

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <img src="/eagle-logo-transparent.png" alt="Eagles Refuge Academy Logo" className="footer-logo" />
            <h3>Eagles Refuge Academy</h3>
            <p>Wings of Wisdom, Hearts of Faith</p>
            <div className="social-links">
              <a href="https://www.facebook.com/people/Eagles-Refuge-Academy/61557114231157/" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><Facebook sx={{ color: 'white' }} /></a>
              <a href="#" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><Instagram sx={{ color: 'white' }} /></a>
            </div>
          </div>

          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><a href="/">Home</a></li>
              <li><a href="/about">About Us</a></li>
              <li><a href="/application">Apply</a></li>
              <li><a href="/contact">Contact</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Portals</h4>
            <ul>
              <li><a href="/student-portal">Student Portal</a></li>
              <li><a href="/teacher-portal">Teacher Portal</a></li>
              <li><a href="/parent-portal">Parent Portal</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Office Hours</h4>
            <p style={{ color: 'white', display: 'flex', flexDirection: 'column' }}>
              <span style={{ fontWeight: 'bold', marginBottom: '4px' }}></span>
              <span>{officeHours.weekdays.days}</span>
              <span>{officeHours.weekdays.hours}</span>
            </p>
            {locationMethod && (
              <p>
                <a 
                  href={`https://maps.google.com/?q=${locationMethod.details.join(',').replace(' ', '+')}`} 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  style={{ color: 'white', textDecoration: 'none', display: 'flex', alignItems: 'center' }}
                >
                  <LocationOn sx={{ color: 'white', mr: 1 }} /> 
                  {locationMethod.details.map((line, index) => (
                    <React.Fragment key={index}>
                      {index > 0 && <br />}
                      {line}
                    </React.Fragment>
                  ))}
                </a>
              </p>
            )}
            {phoneMethod && (
              <p>
                <a 
                  href={`tel:${phoneMethod.details[0].replace(/\D/g, '')}`} 
                  style={{ color: 'white', textDecoration: 'none', display: 'flex', alignItems: 'center' }}
                >
                  <Phone sx={{ color: 'white', mr: 1 }} /> {phoneMethod.details[0]}
                </a>
              </p>
            )}
            {emailMethod && (
              <p>
                <a 
                  href={`mailto:${emailMethod.details[0]}`} 
                  style={{ color: 'white', textDecoration: 'none', display: 'flex', alignItems: 'center' }}
                >
                  <Email sx={{ color: 'white', mr: 1 }} /> {emailMethod.details[0]}
                </a>
              </p>
            )}
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2025 Eagles Refuge Academy. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
